import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {ActivatedRoute} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ListsService} from '../lists.service';
import {ParseService} from '../parse.service';
import {CategoryItems} from '../model/category-items';
import {ListItem} from '../model/list-item';

@Component({
    selector: 'app-shopping-list',
    templateUrl: './shopping-list.component.html',
    styleUrls: ['./shopping-list.component.scss'],
    standalone: false
})
export class ShoppingListComponent implements OnInit {

  itemGroup: UntypedFormGroup;
  items: CategoryItems[];

  constructor(private route: ActivatedRoute, private fb: UntypedFormBuilder,
              private listService: ListsService, private parseService: ParseService, private ref: ChangeDetectorRef) {
    this.itemGroup = fb.group({
      itemName: ['', Validators.required]
    });
  }

  ngOnInit(): void {
    this.route.params.subscribe(params => {
      this.listService.loadById(params.id).subscribe(items => this.items = items);
    });
  }

  updateAmount(item): void {
    this.listService.updateAmount(item);
  }

  isCollected(item: ListItem): boolean {
    return item.amount === item.collected;
  }

  isPartial(item: ListItem): boolean {
    return !this.isCollected(item) && item.collected > 0;
  }

  addExtraItem(): void {
    if (!this.itemGroup.valid) {
      return;
    }

    const itemName = this.getItemName();
    const item = this.parseService.parse(itemName);
    this.listService.addItem(item).then();

    this.itemGroup.setValue({
      itemName: '',
    });
  }

  toggleEnableDisable(): void {
    this.ref.detectChanges();
  }

  private getItemName(): string {
    return this.itemGroup.get('itemName').value;
  }
}
